// Thay đổi import từ axios:
import axios from './custom_axios';
const API_URL = process.env.REACT_APP_API_URL;

const fetchAllProducts = async () => {
    try {
        const response = await axios.get("/dataproduct.json");
        return response.data;
    } catch (error) {
        console.error("Error fetching data", error);
        return [];
    }
}
const fetchAllProducts1 = async (slug) => {
    try {
        const response = await axios.get(`${API_URL}/api/v1/deploy/${slug}`);

        if (!response.data || Object.keys(response.data).length === 0) {
            console.warn("Không có dữ liệu. Chuyển hướng đến trang bảo trì...");
            return null;
        }

        return response.data;
    } catch (error) {

        // window.location.href = "/maintenance";
        return null;
    }
};

const fetchAllUsers = async () => {
    try {
        const response = await axios.get(`${API_URL}/user`);
        // console.log(">>>>CHECK DATA", response.data);
        return response.data;
    } catch (error) {
        return [];
    }
}

const fetchFeatures = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BANK_RETURN_URL}/dataAdd.json`);
        return response.data;
    } catch (error) {
        return [];
    }
}

const fetchImages = async () => {

}

export { fetchAllProducts, fetchAllProducts1, fetchFeatures }

